import { render, staticRenderFns } from "./ConsultantInvoiceDetail.vue?vue&type=template&id=050429ba&scoped=true&"
import script from "./ConsultantInvoiceDetail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConsultantInvoiceDetail.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ConsultantInvoiceDetail.vue?vue&type=style&index=0&id=050429ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050429ba",
  null
  
)

export default component.exports